import { Service, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { MsalGuard, MsalService } from '@azure/msal-angular';
import { filter, map, of, switchMap, take, zip } from 'rxjs';

import { AuthenticationService } from '@core/authentication';
import { ContextStateService } from '@core/services/context-state.service';
import { LocalizationService } from '@core/services/localization';

@Service()
export class AuthenticationGuard {
    private isCurrentContextLoaded$ = toObservable(inject(ContextStateService).isCurrentContextLoaded);
    private isCurrentLanguageLoaded$ = toObservable(inject(LocalizationService).isCurrentLanguageLoaded);
    private msalGuard = inject(MsalGuard);
    private authService = inject(AuthenticationService);
    private msalService = inject(MsalService);

    public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        return this.msalGuard.canActivate(route, state).pipe(
            switchMap((msalResult: boolean | UrlTree) => {
                if (msalResult !== true) {
                    return of(msalResult);
                }

                this.authService.loadCurrentContext();
                return zip(
                    of(msalResult),
                    this.isCurrentContextLoaded$.pipe(
                        filter(isLoaded => !!isLoaded),
                        take(1)
                    ),
                    this.isCurrentLanguageLoaded$.pipe(
                        filter(isLoaded => !!isLoaded),
                        take(1)
                    )
                ).pipe(map(([result]) => result));
            })
        );
    }
}
